/*
This file contains shortcuts for different kinds of modals
 */

import {showModalIframe} from "./utils/modal";

export const MODAL_LOGIN = {
	/**
	 * @param {Function} onClose Callback accepts one parameter of type {object} - dialog's result
	 * @return {ZDialog}
	 */
	show: function(onClose = null) {
		return showModalIframe('login', null, {onClose});
	}
};

export const MODAL_ASK_REDIRECT = {
	/**
	 * @param {object} data
	 * @return {ZDialog}
	 */
	show: function(data = null) {
		return showModalIframe('ask_redirect', data, {
			modal: true
		});
	}
};

export const MODAL_CRITICAL_NEWS = {
	/**
	 * @param {number} id News ID
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function(id, onClose = null) {
		return showModalIframe('critical_news', {id}, {
			modal: true,
			onClose
		});
	}
};

export const MODAL_REVIEW = {
	/**
	 * @param {number} id
	 * @param {number} index
	 * @param {*} filter
	 * @return {ZDialog}
	 */
	show: function(id, index = null, filter = null) {
		return showModalIframe('review', {id, index, filter}, {fullscreen: true});
	}
};

export const MODAL_REVIEW_EDIT = {
    /**
     * @param {number} id
     * @param {number} packageId
     * @param {Object} initialValues
	 * @param {Function} onClose
	 * @return {ZDialog}
     */
	show: function(id, packageId = null, initialValues = {}, onClose = null) {
		let data = {
			id,
			package_id: packageId,
			...initialValues
		};

		return showModalIframe('review_edit', data, {onClose});
	}
};

export const MODAL_QUESTION_EDIT = {
    /**
     * @param {number} id
     * @param {Function} onClose
     * @return {ZDialog}
     */
    show: function(id, onClose = null) {
        return showModalIframe('question_edit', {id}, {onClose});
    }
};

export const MODAL_REVIEW_COMMENT_EDIT = {
    /**
     * @param {number} id
     * @param {Function} onClose
     * @return {ZDialog}
     */
    show: function(id, onClose = null) {
        return showModalIframe('review_comment_edit', {id}, {width: 650, onClose});
    }
};

export const MODAL_CREATE_COMPUTER_ORDER = {
    /**
     * @param {Function} onClose
     * @return {ZDialog}
     */
	show: function(onClose = null) {
        return showModalIframe('create_computer_order', {}, {width: 780, onClose});
    }
};

export const MODAL_FILIALIST_ORDER_PAGE = {
	/**
	 * @param {number} id Package ID
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function(id, onClose = null) {
		return showModalIframe('filialist_order_page', {id}, {type: 'window', onClose});
	}
};

export const MODAL_FILIALIST_EXCLUDE_FROM_PARCEL = {
	/**
	 * @param {number} id Package ID
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function(id, onClose = null) {
		return showModalIframe('filialist_exclude_from_parcel', {id}, {width: 470, onClose});
	}
};

export const MODAL_FILIALIST_FREE_ORDERS_EDIT = {
    /**
     * @param {number} customerId
     * @param {Function} onClose
     * @return {ZDialog}
     */
    show: function(customerId, onClose = null) {
        return showModalIframe(
        	'filialist_free_orders_edit',
			{ customer_id: customerId },
			{ width: 1300, onClose }
		);
    }
};

export const MODAL_FILIALIST_CREATE_TODO = {
    /**
     * @param {number} id
     * @param {string} type
     * @param {Function} onClose
	 * @return {ZDialog}
     */
	show: function(id, type, onClose = null) {
		return showModalIframe('filialist_create_todo', {id, type}, {width: 600, onClose});
    }
};

export const MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS = {
	/**
	 * @param {number[]} ids
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function(ids, onClose = null) {
		return showModalIframe('filialist_reassign_packages_to_customers', {ids},
			{width: 1800, onClose});
	}
};

export const MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER = {
	/**
	 * @param {Function} onClose
	 * @returns {ZDialog}
	 */
	show: function(onClose = null) {
		return showModalIframe('filialist_change_assignment_customer', null,
			{width: 900, onClose});
	}
};

export const MODAL_FILIALIST_EDIT_ASSIGNMENT = {
	/**
	 * @param {number} id
	 * @param {Function} onClose
	 * @returns {ZDialog}
	 */
	show: function (id, onClose = null) {
		return showModalIframe('filialist_edit_assignment', {id}, {width: 500, onClose});
	}
};

export const MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA = {
	/**
	 * @param {string} id
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function (id, onClose = null) {
		return showModalIframe(
			'filialist_get_assignment_meest_data',
			{ id },
			{ width: 450, onClose }
		);
	}
};

export const MODAL_FILIALIST_BATCH_PAYMENT = {
    /**
     * @param {array} ids
	 * $param {string} account
     * @param {number} rate
     * @param {Function} onClose
     * @return {ZDialog}
     */
    show: function(ids, account, rate, onClose = null) {
        return showModalIframe('filialist_batch_payment', {ids, account, rate}, {width: 400, onClose});
    }
};

export const MODAL_FILIALIST_SET_PACKAGE_KINDS = {
	/**
	 * @param {number[]} ids
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function(ids, onClose = null) {
		return showModalIframe('filialist_set_package_kinds', {ids},
			{width: 900, onClose});
	}
};

export const MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES = {
	/**
	 * @param {string[]} cities
	 * @param {Object[]} streets
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function (cities, streets, onClose = null) {
		const data = encodeURIComponent(JSON.stringify({ cities, streets }));
		return showModalIframe('filialist_set_meest_address_aliases', { data }, { onClose });
	}
};

export const MODAL_ADMIN_REPLENISH_BALANCE = {
	/**
	 * @param {number} pendingReplenihmentId
	 * @param {number} boundBankTransactionId
	 * @param {number} suggestionBondId
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show(pendingReplenihmentId, boundBankTransactionId = null, suggestionBondId = null, onClose = null) {
		showModalIframe('admin_replenish_balance', {
			pending_replenihment_id: pendingReplenihmentId,
			bound_bank_transaction_id: boundBankTransactionId,
			suggestion_bond_id: suggestionBondId
		}, {onClose});
	}
};

export const MODAL_ADMIN_BATCH_PAYMENT = {
	/**
	 * @param {string} accountSource
	 * @param {string} accountTarget
	 * @param {number} amount
	 * @param {number} rate
	 * @param {number[]} groupIds
	 * @param {number[]} boundBankTransactionIds
	 * @param {number} suggestionBondId
	 * @param {Function} onClose
	 */
	show(accountSource, accountTarget, amount, rate, groupIds,
		 boundBankTransactionIds, suggestionBondId = null, onClose = null) {
		showModalIframe(
			'admin_batch_payment',
			{
				account_source: accountSource,
				account_target: accountTarget,
				amount,
				rate,
				group_ids: groupIds,
				bound_bank_transaction_ids: boundBankTransactionIds,
				suggestion_bond_id: suggestionBondId
			},
			{width: 500, onClose});
	}
};

export const MODAL_ADMIN_IMPORT_BANK_STATEMENT = {
	/**
	 * @param {Function} onClose
	 * @returns {ZDialog}
	 */
	show(onClose = null) {
		return showModalIframe('admin_import_bank_statement', {}, {width: 800, onClose})
	}
};

export const MODAL_ADMIN_VALIDATE_INVOICE_CSV = {
	/**
	 * @param {string | null} name
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show(name = null, onClose = null) {
		return showModalIframe(
			'admin_validate_invoice_csv',
			{ name },
			{ width: 500, onClose }
		);
	}
};

export const MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS = {
	/**
	 * @returns {ZDialog}
	 */
	show() {
		return showModalIframe('admin_shop_bank_statement_keywords', {}, {width: 1200});
	}
};

export const MODAL_PACKAGE_INFO = {
	/**
	 * @param {number} id Package ID
	 * @param {Function} onClose
	 * @return {ZDialog}
	 */
	show: function(id, onClose = null) {
		return showModalIframe('package_info', {id}, {onClose});
	}
};

export const MODAL_SELECT_SHOP_CATEGORY = {
	show: function(onClose) {
		return showModalIframe('select_shop_category', {}, {width: 550, onClose});
	}
};



// WEBPACK FOOTER //
// ./core/modals.js